export const CONTENTFUL_HOME_ENTRY_ID = "Cac2CY3xIzLMC4FxQ7hRM";
export const CONTENTFUL_NAV_ENTRY_ID = "7MdTf6sO4iT8S4N2wcMxWp";
export const CONTENTFUL_GLOBAL_ENTRY_ID = "7ljpvq7CZK0ozA8ADy3Ixs";
export const CONTENTFUL_NEWSLETTER_ENTRY_ID = "5sdC8IkAkvDyretzY7gE3E";
export const CONTENTFUL_APPROACH_ENTRY_ID = "2MEM4SRvgi1aFzerJoZrjz";
export const CONTENTFUL_ABOUT_ENTRY_ID = "5gJvFGE8ItuRETd87Gjh26";
export const CONTENTFUL_FUNCTIONAL_TESTS_ENTRY_ID = "3uKKPzEJyFbh5y2vbUn02Y";
export const CONTENTFUL_CONSULTATIONS_ENTRY_ID = "6NePZqGaPiacpOuwuTyh7k";
export const CONTENTFUL_PACKAGES_ENTRY_ID = "2wvXoSlL2qrlEBlD5fb9wN";
export const CONTENTFUL_PROGRAMMES_ENTRY_ID = "6ULJtdVs5Ro5s8xJfzbtB5";